export class User {
    id: number;
    name: string;
    password: string;
    token: string;
    email:string;

    constructor (id:number, name:string, password:string, token:string) {
        this.id = id;
        this.name = name;
        this.password = password;
        this.token = token;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/entities/user.ts